import { css } from '@emotion/css'

import { accessiblyHidden } from '../../utils/styleUtils'
import { hexToRgba } from '../../themes/helpers'
import colors from '../../themes/colors'
import { borderRadius, spacing, fontSize } from '../../styles'

const imageWrapper = 120
const buttonWrapper = 34
const iconSize = 20

const styles = {
  imageUpload: css({
    position: 'relative',
    width: imageWrapper,
    height: imageWrapper,
    overflow: 'hidden',
    margin: 0,
    borderRadius: borderRadius.default,
    backgroundColor: colors.hawkesBlue,
    color: colors.cornflowerBlue,
  }),

  hoverOverlay: css({
    position: 'absolute',
    width: imageWrapper,
    height: imageWrapper,
    transition: 'opacity 0.5s',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing.small,
    backgroundColor: hexToRgba(colors.oxfordBlue, 0.5),
    opacity: 0,

    'span, button': {
      height: buttonWrapper,
      width: buttonWrapper,
    },

    'button svg': {
      maxWidth: fontSize.medium,
      maxHeight: fontSize.medium,
    },

    '&:hover': {
      opacity: 1,
    },
  }),

  emptyImage: css({
    textAlign: 'center',
    width: imageWrapper,
    height: imageWrapper,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: spacing.default,
    boxSizing: 'border-box',
    gap: spacing.small,

    '&:hover': {
      cursor: 'pointer',
    },
  }),

  buttonHoverState: css({
    '&:hover': {
      backgroundColor: colors.cornflowerBlue,
      cursor: 'pointer',

      svg: {
        fill: colors.hawkesBlue,
      },
    },

    svg: {
      maxWidth: iconSize,
      maxHeight: iconSize,
    },
  }),

  accessiblyHidden: css(accessiblyHidden),

  imagePreview: css({
    borderRadius: borderRadius.default,
    height: imageWrapper,
    width: imageWrapper,
    objectFit: 'cover',
    objectPosition: 'center center',
  }),

  errorLabel: css({
    boxSizing: 'border-box',
    border: `1px solid ${colors.mandy}`,
  }),

  wrapper: css({
    marginBottom: spacing.medium,

    small: {
      position: 'absolute',
    },
  }),
}

export default styles
